import { render, staticRenderFns } from "./AgentRatingsReviewsPage.vue?vue&type=template&id=487b8e2a&scoped=true"
import script from "./AgentRatingsReviewsPage.vue?vue&type=script&lang=js"
export * from "./AgentRatingsReviewsPage.vue?vue&type=script&lang=js"
import style0 from "./AgentRatingsReviewsPage.vue?vue&type=style&index=0&id=487b8e2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487b8e2a",
  null
  
)

export default component.exports